// @ts-strict-ignore
import type {GridDimensions, GridSetup} from './types';

const SMALL_WIDTH = 400;
const MEDIUM_WIDTH = 750;

const MEDIUM_HEIGHT = 500;

const DEFAULT_8_DIMENSIONS: GridDimensions[] = [
  {columns: 1, rows: 1},
  {columns: 2, rows: 1},
  {columns: 3, rows: 1},
  {columns: 2, rows: 2},
  {columns: 3, rows: 2},
  {columns: 3, rows: 2},
  {columns: 4, rows: 2},
  {columns: 4, rows: 2},
];

const GRID_SETUP_MATRIX: GridSetup[] = [
  // max 4 allowed
  {
    maxWidth: SMALL_WIDTH,
    maxHeight: Number.MAX_SAFE_INTEGER,
    dimensionsForMetrics: [
      {columns: 1, rows: 1},
      {columns: 2, rows: 1},
      {columns: 2, rows: 2},
      {columns: 2, rows: 2},
    ],
  },

  // max 8 allowed
  {
    maxWidth: MEDIUM_WIDTH,
    maxHeight: Number.MAX_SAFE_INTEGER,
    dimensionsForMetrics: DEFAULT_8_DIMENSIONS,
  },

  // max 12 allowed for any larger
  {
    maxWidth: Number.MAX_SAFE_INTEGER,
    maxHeight: MEDIUM_HEIGHT,
    dimensionsForMetrics: [
      ...DEFAULT_8_DIMENSIONS,
      {columns: 5, rows: 2},
      {columns: 5, rows: 2},
      {columns: 6, rows: 2},
      {columns: 6, rows: 2},
    ],
  },

  // break to 3 rows if there's enough height
  {
    maxWidth: Number.MAX_SAFE_INTEGER,
    maxHeight: Number.MAX_SAFE_INTEGER,
    dimensionsForMetrics: [
      ...DEFAULT_8_DIMENSIONS,
      {columns: 3, rows: 3},
      {columns: 4, rows: 3},
      {columns: 4, rows: 3},
      {columns: 4, rows: 3},
    ],
  },
];

// need to make sure GRID_SETUP_MATRIX is sorted by maxWidth for getGridDimensions to work correctly
GRID_SETUP_MATRIX.sort((a, b) => a.maxWidth - b.maxWidth);

export function getGridDimensions(width: number, height: number, numMetrics: number): GridDimensions {
  if (numMetrics === 0) {
    return {columns: 0, rows: 0};
  }

  const setup = GRID_SETUP_MATRIX.find((setupConfig) => width < setupConfig.maxWidth && height < setupConfig.maxHeight);
  const numMetricsSupported = setup.dimensionsForMetrics.length;
  const metricIdx = Math.min(numMetricsSupported, numMetrics) - 1;

  return setup.dimensionsForMetrics[metricIdx];
}
